// extracted by mini-css-extract-plugin
export var container = "ShroomsLogo-module--container--mgyR3";
export var firstP = "ShroomsLogo-module--first-p--AU1bQ";
export var imageWrapper = "ShroomsLogo-module--image-wrapper--1a7tz";
export var img = "ShroomsLogo-module--img--5+8oq";
export var secondP = "ShroomsLogo-module--second-p--FYcHY";
export var single = "ShroomsLogo-module--single--+eOO-";
export var wrapper = "ShroomsLogo-module--wrapper--WmPma";